import React from 'react'
import IconWrapper from './styles'

interface SidebarIconProps {
  onClick?: () => void
}

export const SidebarIcon: React.FC<SidebarIconProps> = ({ onClick }) => {
  return (
    <IconWrapper onClick={onClick} className={'sidebar-icon'}>
      <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.8333 1.875C17.0993 1.875 18.125 2.90066 18.125 4.16667V15.8333C18.125 17.0993 17.0993 18.125 15.8333 18.125H4.16667C2.90066 18.125 1.875 17.0993 1.875 15.8333V4.16667C1.875 2.90066 2.90066 1.875 4.16667 1.875H15.8333ZM8.125 16.875H15.8333C16.409 16.875 16.875 16.409 16.875 15.8333V4.16667C16.875 3.59101 16.409 3.125 15.8333 3.125H8.125V16.875ZM4.16667 3.125C3.59101 3.125 3.125 3.59101 3.125 4.16667V15.8333C3.125 16.409 3.59101 16.875 4.16667 16.875H6.875V3.125H4.16667Z"
            fill="white"
          />
        </g>
      </svg>
    </IconWrapper>
  )
}